var VALID_REGISTRATION_NUMBER_LENGTH = 8

module.exports = function(registrationNumber) {
    return registrationNumber && registrationNumber.length === VALID_REGISTRATION_NUMBER_LENGTH && !isNaN(registrationNumber)
}
